import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppThunk} from './store'; // Import AppThunk for typed thunks
import {MerchantDropDown} from "../../types/MerchantDropDown";

const initialState: MerchantDropDown = {
    SelectedMerchant: null,
    // loading: false,
    // error: null,
};

// const initialState: MerchantDropDown = {};

const dropdownSlice = createSlice({
    name: 'SelectedMerchant',
    initialState,
    reducers: {
        setSelectedMerchant: (
            state,
            action: PayloadAction<{ [key: string]: string | null }>
        ) => {
            Object.assign(state, action.payload);
        },
        setLoading: (
            state,
            action: PayloadAction<{ [key: string]: boolean }>
        ) => {
            // Optionally handle loading state per field
        },
        setError: (
            state,
            action: PayloadAction<{ [key: string]: string | null }>
        ) => {
            // Optionally handle errors per field
        },
    },
});

export const {setSelectedMerchant, setLoading, setError} = dropdownSlice.actions;
export default dropdownSlice.reducer;

// Thunk for async actions
export const fetchAndSetValue =
    (newValue: { [key: string]: string }): AppThunk =>
        async (dispatch) => {
            try {
                dispatch(setLoading({[Object.keys(newValue)[0]]: true}));
                // Simulating an API call
                const response = await new Promise<{ success: boolean; value: { [key: string]: string } }>((resolve) =>
                    setTimeout(() => resolve({success: true, value: newValue}), 1000)
                );

                if (response.success) {
                    dispatch(setSelectedMerchant(response.value));
                } else {
                    throw new Error('Failed to update value');
                }
            } catch (error) {
                dispatch(
                    setError({
                        [Object.keys(newValue)[0]]: (error as Error).message,
                    })
                );
            } finally {
                dispatch(setLoading({[Object.keys(newValue)[0]]: false}));
            }
        };
